import { OnInit } from "@angular/core";
var RadiobuttonComponent = /** @class */ (function () {
    function RadiobuttonComponent() {
    }
    RadiobuttonComponent.prototype.ngOnInit = function () { };
    return RadiobuttonComponent;
}());
export { RadiobuttonComponent };
